import * as types from "../types/auth.types";
import { loginUser, loginUserMartRocky, loginUserRocky } from "../../services/auth.services";
import {
  // openNotification,
  swalNotification,
  // swalLoginNotification,
} from "../../components/alret/notificztion";

export const loginUserAction = (email, password, navigate) => {
  // console.log('loginUserAction is calling')
  return async (dispatch) => {
    dispatch({
      type: types.SET_USER_LOADING,
      payload: true,
    });
    try {
      if(process.env.REACT_APP_K2_ACCOUNTS_REDIS == "true"){
        await loginUser(email, password).then((res) => {
          if (res.data.code === 200) {
            // dispatch({
            //   type: LOGIN_USER_SUCCESS,
            //   payload: response.data,
            // });
            dispatch({
              type: types.SET_USER,
              payload: res.data.data,
            });
            dispatch({
              type: types.SET_TOKEN,
              payload: res.data.data.token,
            });
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("user", res.data.data.name);
            localStorage.setItem("user_id", res.data.data.id);
            // alert('Login user success')
            // SetLocalItem('token', response?.data?.token);
            // SetLocalItem('uid', response?.data?.user?._id);
            navigate("/overview");
          }
          dispatch({
            type: types.SET_USER_LOADING,
            payload: false,
          });
        });
      } else {
        await loginUserRocky(email, password).then((res) => {
          if (res.data.code === 200) {
            dispatch({
              type: types.SET_USER,
              payload: res.data.data,
            });
            dispatch({
              type: types.SET_TOKEN,
              payload: res.data.data.token,
            });
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("user", res.data.data.name);
            localStorage.setItem("user_id", res.data.data.id);
            navigate("/overview");
          }
          dispatch({
            type: types.SET_USER_LOADING,
            payload: false,
          });
        });
      }
    } catch (e) {
      if (e.response.status == 401 || e.response.statusText == "Unauthorized") {
        swalNotification(
          "Unauthorized invalid email or password",
          e.message,
          "error"
        );
      } else {
        swalNotification(e.message, e.message, "error");
      }
      dispatch({
        type: types.SET_USER_LOADING,
        payload: false,
      });
    }
  };
};

export const loginUserMartAction = (email, password, navigate) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_USER_LOADING,
      payload: true,
    });
    try {
      if(process.env.REACT_APP_K2_ACCOUNTS_REDIS == "true"){
        await loginUser(email, password).then((res) => {
          if (res.data.code === 200) {
            dispatch({
              type: types.SET_USER,
              payload: res.data.data,
            });
            dispatch({
              type: types.SET_TOKEN,
              payload: res.data.data.token,
            });
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("user", res.data.data.name);
            localStorage.setItem("user_id", res.data.data.id);
            navigate("/overview");
          }
          dispatch({
            type: types.SET_USER_LOADING,
            payload: false,
          });
        });
      } else {
        await loginUserMartRocky(email, password).then((res) => {
          if (res.data.code === 200) {
            dispatch({
              type: types.SET_USER,
              payload: res.data.data,
            });
            dispatch({
              type: types.SET_TOKEN,
              payload: res.data.data.token,
            });
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("user", res.data.data.name);
            localStorage.setItem("user_id", res.data.data.id);
            navigate("/overview");
          }
          dispatch({
            type: types.SET_USER_LOADING,
            payload: false,
          });
        });
      }
    } catch (e) {
      if (e.response.status == 401 || e.response.statusText == "Unauthorized") {
        swalNotification(
          "Unauthorized invalid email or password",
          e.message,
          "error"
        );
      } else {
        if(e.response.data.message == "Validation Error"){
          swalNotification(e.response.data.data.email, e.message, "error");
        } else {
          swalNotification(e.message, e.message, "error");
        }
      }
      dispatch({
        type: types.SET_USER_LOADING,
        payload: false,
      });
    }
  };
};

export const logoutUserAction = (navigate) => {
  return async (dispatch) => {
    await dispatch({
      type: types.LOGOUT_USER,
    });
  };
};

export const GetUserInfoAction = () => {
  return async (dispatch) => {
    //   try {
    //     let response = await getUserInfo(contractPhnxStake, web3context);
    //     // console.log("res in GetUserInfoAction", response);
    //     dispatch({
    //       type: types.GET_USER_INFO_SUCCESS,
    //       payload: response,
    //     });
    //   } catch (e) {
    //     // console.log("Err at GetUserInfoAction", e);
    //     dispatch({
    //       type: types.GET_USER_INFO_ERROR,
    //       payload: e?.response?.data?.message || e.message,
    //     });
    //   }
  };
};

export const navbarCollapsedAction = (value) => {
  return async (dispatch) => {
    dispatch({
      type: types.NAVBAR_COLLAPSED,
      payload: value,
    });
  };
};